import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';

import { DeleteProjectStatus } from '../project.actions';

@Component({
    selector: 'app-project-status-delete-modal',
    templateUrl: './project-status-delete-modal.component.html',
    styleUrls: ['./project-status-delete-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ProjectStatusDeleteModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() projectStatusUuid: string;
    errorMessage: string;

    constructor(public activeModal: NgbActiveModal, private store: Store, private logger: NGXLogger) {}

    ngOnInit(): void {}

    deleteProjectStatus() {
        this.logger.debug('Attempt to delete projectStatus');
        this.subscriptions.add(
            this.store.dispatch(new DeleteProjectStatus(this.projectStatusUuid)).subscribe(
                () => {
                    this.logger.debug('Succesfully deleted project status');
                    this.activeModal.close();
                },
                (error) => {
                    this.logger.debug('Failed to delete project status');
                    this.errorMessage = error?.error?.message ?? 'Error message was empty';
                },
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
